import LuckyDrawDetailCard from "./luckyDrawDetailCard.container";

export default LuckyDrawDetailCard;
